import { render } from "./manualCampaignDetailsDialog.vue?vue&type=template&id=aff92a3e&scoped=true"
import script from "./manualCampaignDetailsDialog.vue?vue&type=script&lang=js"
export * from "./manualCampaignDetailsDialog.vue?vue&type=script&lang=js"

import "./manualCampaignDetailsDialog.vue?vue&type=style&index=0&id=aff92a3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aff92a3e"]])

export default __exports__